import {connect} from 'react-redux';
import classNames from 'classnames';

import {gettext} from 'topmeteo/utils/i18n';

import {confirmNotification} from '../../actionCreators';

import MarkSafe from '../../../general/components/MarkSafe';

const CloseLabel = gettext('Close');

const Notification = ({text, tags, onClick}) => (
    <div className={classNames('notification', tags)}>
        <div className="notifications-inner">
            <MarkSafe Element="p" value={text} />
            <div className="close">
                <a href="#" onClick={onClick}>
                    <span className="sr-only">{CloseLabel}</span>
                </a>
            </div>
        </div>
    </div>
);

const mapDispatchToProps = (dispatch, {id}) => ({
    onClick: event => {
        event.preventDefault();

        return dispatch(confirmNotification(id));
    },
});

export default connect(undefined, mapDispatchToProps)(Notification);
